import { cx, useAppVariant } from "@jugl-web/utils";
import { useAnimatedCount } from "@jugl-web/utils/hooks/useAnimatedCount";
import { FC, SVGProps, useCallback } from "react";

interface KPICardProps {
  id: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  value: number;
  className?: string;
}

const animatedMap = new Map<string, boolean>();

export const KPICard: FC<KPICardProps> = ({
  id,
  Icon,
  label,
  value,
  className,
}) => {
  const { isMobile } = useAppVariant();
  const handleComplete = useCallback(() => {
    animatedMap.set(id, true);
  }, [id]);

  const animatedValue = useAnimatedCount({
    targetValue: value,
    isDisabled: animatedMap.get(id) ?? false,
    onComplete: handleComplete,
  });

  if (isMobile)
    return (
      <div
        className={cx(
          "flex h-[68px] items-center gap-2 rounded-xl border border-solid border-grey-300 px-5",
          className
        )}
      >
        <Icon className="h-5 w-5 shrink-0" />
        <span className="ml-0.5 font-secondary text-xl font-semibold text-dark">
          {animatedValue}
        </span>
        <span className="font-secondary text-xs text-dark-800">{label}</span>
      </div>
    );

  return (
    <div
      className={cx(
        "flex flex-1 flex-col gap-3 rounded-xl border border-solid border-[#DEDEE4] bg-white p-5 transition-all ring-inset hover:border-grey-300 hover:ring-1 hover:ring-grey-300",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5 shrink-0" />
        <span className="font-secondary text-sm font-medium text-[#40494D]">
          {label}
        </span>
      </div>
      <span className="font-secondary text-[32px] leading-[1.4] font-semibold text-[#1A2023]">
        {animatedValue}
      </span>
    </div>
  );
};
